import * as Sentry from '@sentry/react';
import { version } from "../../package.json";

export const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    release: version,
    sendDefaultPii: true,
    enableLogs: true,
     integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0 ,
  });
  
}